import styled, { spacing } from "@rentiohq/web-theme";

export const Intro = styled.p`
  margin: ${spacing("loose")} 0 0;
`;

export const Body = styled.p`
  margin: ${spacing("tight")} 0 0;
  line-height: 1.5;
`;

export const ErrorMessage = styled.div`
  margin: ${spacing("loose")} 0 0;
`;

export const Identity = styled.p`
  margin: ${spacing("loose")} 0 0;
  font-size: 14px;
`;

export const Actions = styled.div`
  display: flex;
  gap: ${spacing()};
  margin-top: ${spacing("extraLoose")};

  button {
    white-space: nowrap;
  }
`;
